import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
  DocumentoSetorialDetailsState,
  DocumentoSetorialDetailsAction,
  DocumentoSetorialDetailsReducer,
} from './documento-setorial-details-reducer';

const initialState: DocumentoSetorialDetailsState = {
  documentoSetorialDetails: null,
  loading: false,
  error: null,
};

const DocumentoSetorialDetailsStateContext = createContext<DocumentoSetorialDetailsState | undefined>(undefined);
const DocumentoSetorialDetailsDispatchContext = createContext<React.Dispatch<DocumentoSetorialDetailsAction> | undefined>(undefined);

interface DocumentoSetorialDetailsProviderProps {
  children: ReactNode;
}

export const DocumentoSetorialDetailsProvider: React.FC<DocumentoSetorialDetailsProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(DocumentoSetorialDetailsReducer, initialState);

  return (
    <DocumentoSetorialDetailsStateContext.Provider value={state}>
      <DocumentoSetorialDetailsDispatchContext.Provider value={dispatch}>
        {children}
      </DocumentoSetorialDetailsDispatchContext.Provider>
    </DocumentoSetorialDetailsStateContext.Provider>
  );
};

export const useDocumentoSetorialDetailsState = (): DocumentoSetorialDetailsState => {
  const context = useContext(DocumentoSetorialDetailsStateContext);
  if (context === undefined) {
    throw new Error('useDocumentoSetorialDetailsState must be used within a DocumentoSetorialDetailsProvider');
  }
  return context;
};

export const useDocumentoSetorialDetailsDispatch = (): React.Dispatch<DocumentoSetorialDetailsAction> => {
  const context = useContext(DocumentoSetorialDetailsDispatchContext);
  if (context === undefined) {
    throw new Error('useDocumentoSetorialDetailsDispatch must be used within a DocumentoSetorialDetailsProvider');
  }
  return context;
};
